import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  ElementRef
} from "@angular/core";
import { item, MerchantItems } from "src/app/models/items";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { GeneralService } from "src/app/services/general.service";
import { CommunicationService } from "src/app/services/communication.service";
import { MockStoreService } from "src/app/services/mock-store.service";
// import { Merchant, } from "src/app/models/merchant";
import { fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-items",
  templateUrl: "./items.component.html",
  styleUrls: ["./items.component.css"]
})
export class ItemsComponent implements OnInit, AfterViewInit {
  @Input("searchInput") searchInput: ElementRef;
  itemsList: MerchantItems[] = [];
  loading: boolean = false;
  additionalProductInfo: boolean = false;
  deleteMode: boolean = false;
  itemsToDelete: Array<MerchantItems> = [];
  batchDeleteMode: boolean = false;
  spareItems: MerchantItems[] = [];
  searchTerm: string;
  searching: boolean = false;
  constructor(
    private fb: FormBuilder,
    private generalservice: GeneralService,
    private commservice: CommunicationService,
    private mockstore: MockStoreService,
    private activatedroute: ActivatedRoute
  ) {
    this.activatedroute.queryParams.subscribe(val => {
      if (val.hasOwnProperty("redirect") && val["redirect"] == "catalogue") {
        this.addItem();
      }
    });
  }

  ngOnInit() {
    this.getAllItems();
    this.generalservice.refresh$.subscribe(val => {
      if (val.length < 1) return;
      if (val.trim() == "refreshItems") {
        this.getAllItems();
      }
    });
    // this temporary sha, i will find a better way to hide it
    document
      .querySelectorAll("button.owl-dot")
      .forEach((element: HTMLElement) => (element.hidden = true));
  }

  ngAfterViewInit() {
    // get the search Input ready;
    // const search = this.searchInput.nativeElement as HTMLInputElement;
    // // create observable from search
    // fromEvent(search, "input")
    //   .pipe(debounceTime(500))
    //   .subscribe(val => console.log(val));
  }

  addItem() {
    this.generalservice.additemNotification("addItems");
  }

  getAllItems() {
    this.loading = true;
    this.commservice.fetchAllItems().subscribe(
      val => {
        const { data } = val;
        this.itemsList = data;
        // console.log(this.itemsList);
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.itemsList = [];
        this.generalservice.errorNotification(
          "Could not fetch the requested resource"
        );
      }
    );
  }

  viewItem(item: MerchantItems) {
    // mostRecentlyAddedItem can be just added or viewed
    this.mockstore.mostRecentlyAddedItem = item;
    this.generalservice.singleMerchantCtrl(item);
    this.generalservice.switchSidebarOnOrOff({
      switcher: "on",
      message: "",
      component: "view-content"
    });
    // console.log(item);
  }

  // starts single delete
  deleteItemStart(item?: MerchantItems, batchDelete?: boolean) {
    if (batchDelete) {
      this.deleteMode = true;
      return;
    }
    this.deleteMode = true;
    this.itemsToDelete.push(item);
  }

  // actually deletes an item
  async deleteItem(event: Event) {
    const button = event.srcElement as HTMLButtonElement;
    button.innerText = "Deleting...";
    for (let item of this.itemsToDelete) {
      try {
        const response = await this.commservice.deleteItem(item.id.toString());
        const { message } = response;
        this.itemsList = this.itemsList.filter(anItem => anItem.id != item.id);
        this.generalservice.successNotification(message);
      } catch (error) {
        console.log(error);
      }
    }

    this.deleteMode = false;
    this.batchDeleteMode = false;
    button.innerText = "YES";
    this.itemsToDelete = [];
  }

  // starts the batchDelete
  startBatchDeletMode(event: Event) {
    console.log(event);
    this.batchDeleteMode = !this.batchDeleteMode;
  }

  // cancels delete mode
  cancelDelete() {
    this.deleteMode = !this.deleteMode;
    this.batchDeleteMode = false;
    this.itemsToDelete = [];
  }

  // // searchFunction
  searchDB(event: Event) {
    const element = event.srcElement as HTMLInputElement;
    if (element.value.length > 2) {
      this.spareItems = [...this.itemsList];
      this.searchTerm = element.value;
      this.itemsList = [];
      this.searching = true;
      this.commservice
        .searchItems({ search: element.value, page_number: "0" })
        .subscribe(
          val => {
            const { data } = val;
            if (data.length > 0) {
              this.searching = false;
              this.deleteMode = false;
              this.batchDeleteMode = false;
              this.itemsList = [...data];
            } else {
              this.searching = false;
              this.deleteMode = false;
              this.batchDeleteMode = false;
              this.itemsList = [];
            }
          },
          err => console.log(err)
        );
    } else {
      this.searching = false;
      this.deleteMode = false;
      this.batchDeleteMode = false;
      if (this.spareItems.length > 0) {
        this.itemsList = [...this.spareItems];
      }
      return;
    }
  }

  goBack() {
    this.itemsList = [...this.spareItems];
    this.searchTerm = "";
    this.searching = false;
  }

  tryAgain(){
    this.getAllItems();
  }
}
